// Import Custom Components...
import Button from '../components/form/Button.vue'
import Checkbox from '../components/form/Checkbox.vue'
import DatePicker from '../components/form/DatePicker.vue';
import Error from '../components/Error.vue'
import Input from '../components/form/Input.vue';
import ModalComponent from '../components/Modal.vue';
import Radio from '../components/form/Radio.vue';
import VSelectContainer from '../components/form/SelectContainer.vue';
//website component
import HIggForm from "../components/website/HIggForm.vue";
import SlcpForm from "../components/website/SlcpForm.vue";
import IsoForm from "../components/website/IsoForm.vue";
import SustainabilityForm from "../components/website/SustainabilityForm.vue";

const components = {
    DatePicker,
    Button,
    Checkbox,
    Error,
    Input,
    ModalComponent,
    Radio,
    VSelectContainer,
    HIggForm,
    SlcpForm,
    IsoForm,
    SustainabilityForm
};
export default {
    install(app) {
        Object.entries(components).forEach(([name, component]) => {
            app.component(name, component);
        });
    }
};
